import React, { useEffect, useState } from 'react';
export const Timer = () => {
  const [time, setTime] = useState({
    hours: 5,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prevTime => {
        if (prevTime.seconds > 0) {
          return {
            ...prevTime,
            seconds: prevTime.seconds - 1
          };
        } else if (prevTime.minutes > 0) {
          return {
            ...prevTime,
            minutes: prevTime.minutes - 1,
            seconds: 59
          };
        } else if (prevTime.hours > 0) {
          return {
            hours: prevTime.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          clearInterval(interval);
          return prevTime;
        }
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (value: number) => {
    return value < 10 ? `0${value}` : value;
  };
  return <div className="flex justify-center gap-4 text-center" data-id="element-198">
      <div className="bg-white bg-opacity-20 p-3 rounded-lg" data-id="element-199">
        <div className="text-3xl font-bold" data-id="element-200">{formatTime(time.hours)}</div>
        <div className="text-xs uppercase" data-id="element-201">godzin</div>
      </div>
      <div className="bg-white bg-opacity-20 p-3 rounded-lg" data-id="element-202">
        <div className="text-3xl font-bold" data-id="element-203">{formatTime(time.minutes)}</div>
        <div className="text-xs uppercase" data-id="element-204">minut</div>
      </div>
      <div className="bg-white bg-opacity-20 p-3 rounded-lg" data-id="element-205">
        <div className="text-3xl font-bold" data-id="element-206">{formatTime(time.seconds)}</div>
        <div className="text-xs uppercase" data-id="element-207">sekund</div>
      </div>
    </div>;
};